import Swal from 'sweetalert2';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Profesores = {
    agregarProfesor: async (data) => {
        let url = url_json + "/profesor-curso"
        let body = {
            nombre: data.nombre,
            certificado: data.certificado,
            imagen: data.imagen
        };

        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Profesor agregado correctamente' ,
              'success'
            ).then(() => {
              window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar el profesor, codigo: ' + res.message ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerProfesores: async () => {
        let url = url_json + "/profesor-curso"
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnProfesor: async id => {
        let url = url_json + "/profesor-curso/" + id
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarProfesor: async (data, id) => {
        let url = url_json + "/profesor-curso/" + id;

        let body = {
            nombre: data.nombre,
            certificado: data.certificado,
            imagen: data.imagen
        };

        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Profesor modificado correctamente' ,
                'success'
            ).then(() => {
                window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar el profesor' ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data };
    },
    eliminarProfesor: async id => {
        let url = url_json + "/profesor-curso/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Profesor eliminado correctamente' ,
                'success'
            ).then(() => {
                window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar el profesor',
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data };
    }
}

export default Profesores;
